import { requirementCourseEnrollmentContract } from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation } from "@tanstack/react-query";
import { type z } from "zod";

const startCourseEnrollmentRequestSchema =
  requirementCourseEnrollmentContract.createRequirementCourseEnrollment.body;
const { 201: startCourseEnrollmentResponseSchema } =
  requirementCourseEnrollmentContract.createRequirementCourseEnrollment.responses;

export type StartCourseEnrollmentRequest = z.input<typeof startCourseEnrollmentRequestSchema>;
export type StartCourseEnrollmentResponse = z.infer<typeof startCourseEnrollmentResponseSchema>;

export function useStartCourseEnrollment() {
  return useMutation({
    mutationFn: async (request: StartCourseEnrollmentRequest) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/requirement-course-enrollments`,
        data: request,
        requestSchema: startCourseEnrollmentRequestSchema,
        responseSchema: startCourseEnrollmentResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: "Failed to start course enrollment",
    },
  });
}
